import React, { useState, useEffect } from 'react'
import EchoesCH1 from '../Echoes/EchoesCH1';
import EchoesCH2 from '../Echoes/EchoesCH2';
import EchoesCH3 from '../Echoes/EchoesCH3';
import EchoesCH4 from '../Echoes/EchoesCH4';
import EchoesCH5 from '../Echoes/EchoesCH5';
import EchoesCH6 from '../Echoes/EchoesCH6';
import EchoesCH7 from '../Echoes/EchoesCH7';
import EchoesCH8 from '../Echoes/EchoesCH8';
import EchoesCH9 from '../Echoes/EchoesCH9';
import EchoesCH10 from '../Echoes/EchoesCH10'
import EchoesCH11 from '../Echoes/EchoesCH11'
import EchoesCH12 from '../Echoes/EchoesCH12'
import EchoesCH13 from '../Echoes/EchoesCH13'

import "./../styles/article.css";

const EchoesOfHarmony = () => {

    const [currentChapter, setCurrentChapter] = useState(() => {
        const savedChapter = localStorage.getItem("currentChapter");
        return savedChapter ? JSON.parse(savedChapter) : 0;
    });

    useEffect(() => {
        localStorage.setItem("currentChapter", JSON.stringify(currentChapter));
    }, [currentChapter]);

    useEffect(() => {
        // Scroll to the top of the page whenever the chapter changes
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Adds a smooth scrolling effect
        });
    }, [currentChapter]);

    const nextChapter = () => {
        setCurrentChapter((prevChapter) => Math.min(prevChapter + 1, 13));
    };

    const prevChapter = () => {
        setCurrentChapter((prevChapter) => Math.max(prevChapter - 1, 0));
    };




    return (


        <>
            {currentChapter === 0 ? (
                <div className="title-screen">
                    <div id='echoes-title' style={{ backgroundImage: `url('images/echoes/title-bg.jpg')` }}>
                        <h1>Echoes of Harmony</h1>
                        <h3>One extraordinary weekend. A bond formed, with the promise of friendships that could last a lifetime.</h3>


                        <p>A Show Choir Short Story</p>
                        <p>By</p>
                        <p>Randall Alvin Bayne</p>

                        <button onClick={nextChapter} className='echo-bgn'>Begin Reading</button>




                    </div>
                </div>
            ) : (
                <div className='echoes-bg'>
                    <div className="article-container">
                        <div className='article-chapter-control'>
                            <span className='chapter-lbl'>Chapter {currentChapter} / 13</span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <button className='chapter-btn' onClick={prevChapter}><img src='images/arrow-left.png' /></button>
                                <button className='chapter-btn' onClick={nextChapter}><img src='images/arrow-right.png' /></button>
                            </div>

                        </div>
                        <div className="echoes-border">
                            {currentChapter === 1 ? (
                                <EchoesCH1 />
                            ) : currentChapter === 2 ? (
                                <EchoesCH2 />
                            ) : currentChapter === 3 ? (
                                <EchoesCH3 />
                            ) : currentChapter === 4 ? (
                                <EchoesCH4 />
                            ) : currentChapter === 5 ? (
                                <EchoesCH5 />
                            ) : currentChapter === 6 ? (
                                <EchoesCH6 />
                            ) : currentChapter === 7 ? (
                                <EchoesCH7 />
                            ) : currentChapter === 8 ? (
                                <EchoesCH8 />
                            ) : currentChapter === 9 ? (
                                <EchoesCH9 />
                            ) : currentChapter === 10 ? (
                                <EchoesCH10 />
                            ) : currentChapter === 11 ? (
                                <EchoesCH11 />
                            ) : currentChapter === 12 ? (
                                <EchoesCH12 />
                            ) : currentChapter === 13 ? (
                                <EchoesCH13 />
                            ) : (
                                <></>
                            )}
                        </div>


                        <div className='article-chapter-control'>
                            <span className='chapter-lbl'>Chapter {currentChapter} / 13</span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <button className='chapter-btn' onClick={prevChapter}><img src='images/arrow-left.png' /></button>
                                <button className='chapter-btn' onClick={nextChapter}><img src='images/arrow-right.png' /></button>
                            </div>

                        </div>
                    </div>



                </div>
            )}
        </>


    )
}

export default EchoesOfHarmony